import { render } from "./FlightConfirmation.vue?vue&type=template&id=5a87f03e&scoped=true"
import script from "./FlightConfirmation.vue?vue&type=script&lang=js"
export * from "./FlightConfirmation.vue?vue&type=script&lang=js"

import "./FlightConfirmation.vue?vue&type=style&index=0&id=5a87f03e&lang=scss&scoped=true"
import "./FlightConfirmation.vue?vue&type=style&index=1&id=5a87f03e&lang=scss"
import "./FlightConfirmation.vue?vue&type=style&index=2&id=5a87f03e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a87f03e"]])

export default __exports__